import React from "react";
import PropTypes from "prop-types";

//sub-components
import ApprovalLevelsContainer from "../../../../../features/document/edit/decision/approvalLevels/components/ApprovalLevelsContainer";
import { withRights } from "providers/RightsConsumer";

export const OfferCompetenceOrderContainer = ({ documentId, siteId, rights }) => {
  return (
    <React.Fragment>
      {rights.decisionApprovalLevelRead && <ApprovalLevelsContainer documentId={documentId} siteId={siteId} />}
    </React.Fragment>
  );
};

OfferCompetenceOrderContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  rights: PropTypes.object.isRequired
};

export default withRights(OfferCompetenceOrderContainer);
